import React from 'react';
import { specialTexts } from '../contexts/LangOIT';

function ProductOITSpecial({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100%',           // 100vw → 100%
        maxWidth: '100%',        // 100vw → 100%
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        overflowX: 'hidden'      // 혹시 모를 오버플로 방지
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.5rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center',
        width: '100%'
      }}>
        {specialTexts.title[lang]}
      </span>
      <div
        className="oit-special-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
          columnGap: isMobile ? 0 : 90,
          rowGap: isMobile ? 20 : 32,
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: isMobile ? '20px 16px 30px 16px' : '32px 16px 40px 16px',
          boxSizing: 'border-box'
        }}
      >
        {/* 1 */}
        <div style={{
          background: '#DAE3F3',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: '24px 32px',
          fontSize: '1.3rem',
          fontWeight: 600,
          color: '#29225C',
          width: '100%',
          minHeight: 320 // 세로 사이즈를 기존 대비 2배로 늘림 (기존 160px 기준)
        }}>
          <div style={{
            fontSize: '1.3rem',
            fontWeight: 600,
            marginBottom: 16
          }}>
            {specialTexts.detectiontitle[lang]}
          </div>
          <div style={{
            display: 'flex',
            width: '100%'
          }}>
            <div style={{
              flex: 1,
              fontSize: '1.1rem',
              fontWeight: 500,
              color: '#222',
              display: 'flex',
              alignItems: 'center'
            }}>
              {specialTexts.detectionmessage[lang]}
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              position: 'relative'
            }}>
              <TargetSVG size={200} />
              {/* 기존 이미지 대신 CameraSVG 사용 */}
            </div>
          </div>
        </div>
        {/* 2 */}
        <div style={{
          background: '#DAE3F3',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: '24px 32px',
          fontSize: '1.3rem',
          fontWeight: 600,
          color: '#29225C',
          width: '100%',
          minHeight: 320 // 세로 사이즈를 기존 대비 2배로 늘림 (기존 160px 기준)
        }}>
          <div style={{
            fontSize: '1.3rem',
            fontWeight: 600,
            marginBottom: 16
          }}>
            {specialTexts.historytitle[lang]}
          </div>
          <div style={{
            display: 'flex',
            width: '100%'
          }}>
            <div style={{
              flex: 1,
              fontSize: '1.1rem',
              fontWeight: 500,
              color: '#222',
              display: 'flex',
              alignItems: 'center'
            }}>
              {specialTexts.historymessage[lang]}
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              position: 'relative'
            }}>
              <CameraSVG size={200} />
              {/* 기존 이미지 대신 ReadingGlasses 사용 */}
            </div>
          </div>
        </div>
        {/* 3 */}
        <div style={{
          background: '#DAE3F3',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: '24px 32px',
          fontSize: '1.3rem',
          fontWeight: 600,
          color: '#29225C',
          width: '100%',
          minHeight: 320 // 세로 사이즈를 기존 대비 2배로 늘림 (기존 160px 기준)
        }}>
          <div style={{
            fontSize: '1.3rem',
            fontWeight: 600,
            marginBottom: 16
          }}>
            {specialTexts.audittitle[lang]}
          </div>
          <div style={{
            display: 'flex',
            width: '100%'
          }}>
            <div style={{
              flex: 1,
              fontSize: '1.1rem',
              fontWeight: 500,
              color: '#222',
              display: 'flex',
              alignItems: 'center'
            }}>
              {specialTexts.auditmessage[lang]}
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              position: 'relative'
            }}>
              <ReadingGlasses size={200} />
              {/* 기존 이미지 대신 ReadingGlasses 사용 */}
            </div>
          </div>
        </div>
        {/* 4 */}
        <div style={{
          background: '#DAE3F3',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: '24px 32px',
          fontSize: '1.3rem',
          fontWeight: 600,
          color: '#29225C',
          width: '100%',
          minHeight: 320 // 세로 사이즈를 기존 대비 2배로 늘림 (기존 160px 기준)
        }}>
          <div style={{
            fontSize: '1.3rem',
            fontWeight: 600,
            marginBottom: 16
          }}>
            {specialTexts.processtitle[lang]}
          </div>
          <div style={{
            display: 'flex',
            width: '100%'
          }}>
            <div style={{
              flex: 1,
              fontSize: '1.1rem',
              fontWeight: 500,
              color: '#222',
              display: 'flex',
              alignItems: 'center'
            }}>
              {specialTexts.processmessage[lang]}
            </div>
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              position: 'relative'
            }}>
              <ChipSVG size={200} />
              {/* 기존 이미지 대신 ChipSVG 사용 */}
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          @media (max-width: 900px) {
            .oit-special-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </div>
  );
}

function CameraSVG({ size = 64 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      style={{
        padding: 8,
        display: 'block'
      }}
    >
      {/* 카메라 본체 */}
      <rect x="18" y="20" width="32" height="24" rx="4" fill="#3a3570" stroke="#3a3570" strokeWidth="2"/>
      {/* 삼각형 렌즈(왼쪽) */}
      <polygon points="18,32 8,24 8,40" fill="#3a3570" stroke="#3a3570" strokeWidth="2"/>
      {/* 렌즈 안의 원 */}
      <circle cx="28" cy="32" r="5" fill="#fff" stroke="#035BFB" strokeWidth="2"/>
      {/* 셔터 버튼(상단) */}
      <rect x="38" y="16" width="8" height="6" rx="2" fill="#035BFB"/>
    </svg>
  );
}

function ReadingGlasses({ size = 80 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      style={{
        display: 'block',
        padding: 8
      }}
    >
      {/* 돋보기 원 */}
      <circle cx="28" cy="28" r="16" stroke="#3a3570" strokeWidth="3" fill="#fff"/>
      {/* 손잡이 */}
      <rect x="39" y="39" width="16" height="5" rx="2.5" transform="rotate(45 39 39)" fill="#035BFB"/>
    </svg>
  );
}

function ChipSVG({ size = 64 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      style={{
        display: 'block',
        padding: 8
      }}
    >
      {/* 칩 본체 */}
      <rect x="16" y="16" width="32" height="32" rx="6" fill="#fff" stroke="#3a3570" strokeWidth="3"/>
      {/* 칩 내부 회로선 */}
      <rect x="26" y="26" width="12" height="12" rx="2" fill="#E3EDFF" stroke="#035BFB" strokeWidth="2"/>
      {/* 칩 다리 */}
      {/* 위 */}
      <rect x="29" y="6" width="6" height="8" rx="2" fill="#3a3570"/>
      {/* 아래 */}
      <rect x="29" y="50" width="6" height="8" rx="2" fill="#3a3570"/>
      {/* 왼쪽 */}
      <rect x="6" y="29" width="8" height="6" rx="2" fill="#3a3570"/>
      {/* 오른쪽 */}
      <rect x="50" y="29" width="8" height="6" rx="2" fill="#3a3570"/>
      {/* 대각선 다리 */}
      <rect x="13" y="13" width="6" height="6" rx="2" transform="rotate(-45 13 13)" fill="#035BFB"/>
      <rect x="45" y="13" width="6" height="6" rx="2" transform="rotate(35 50 13)" fill="#035BFB"/>
      <rect x="13" y="45" width="6" height="6" rx="2" transform="rotate(45 13 45)" fill="#035BFB"/>
      <rect x="45" y="45" width="6" height="6" rx="2" transform="rotate(-45 50 45)" fill="#035BFB"/>
    </svg>
  );
}

function TargetSVG({ size = 64 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      style={{
        display: 'block',
        padding: 8
      }}
    >
      {/* 바깥 원 */}
      <circle cx="32" cy="32" r="28" stroke="#3a3570" strokeWidth="3" fill="#fff"/>
      {/* 중간 원 */}
      <circle cx="32" cy="32" r="18" stroke="#035BFB" strokeWidth="2" fill="none"/>
      {/* 안쪽 원 */}
      <circle cx="32" cy="32" r="8" stroke="#3a3570" strokeWidth="2" fill="#DAE3F3"/>
      {/* 중앙 점 */}
      <circle cx="32" cy="32" r="3" fill="#035BFB"/>
      {/* 십자선 */}
      <line x1="32" y1="8" x2="32" y2="18" stroke="#035BFB" strokeWidth="2"/>
      <line x1="32" y1="46" x2="32" y2="56" stroke="#035BFB" strokeWidth="2"/>
      <line x1="8" y1="32" x2="18" y2="32" stroke="#035BFB" strokeWidth="2"/>
      <line x1="46" y1="32" x2="56" y2="32" stroke="#035BFB" strokeWidth="2"/>
    </svg>
  );
}

export default ProductOITSpecial;